<template>
    <div v-loading="dataLoading">
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
            size="medium"
        >
            <div class="group">
                <div class="page-group-title"><span>用户信息</span></div>
                <UserInfo :formData.sync="formData"></UserInfo>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>服务费</span></div>
                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="serviceFeeType" label="服务费用收取方式:" :rules="[{required:true,message:'请选择服务费用收取方式'}]">
                            <el-select v-model="formData.serviceFeeType" @change="scopeChange">
                                <el-option :value="0" label="不收取"></el-option>
                                <el-option :value="1" label="固定金额"></el-option>
                                <el-option :value="2" label="按比例收取"></el-option>
                            </el-select>						
                        </el-form-item>
                    </el-col>		
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="serviceFee" label="服务费用:" :rules="[{required:true,message:'请输入服务费用'}]">
                            <el-row :gutter="10">
                                <el-col :span="22">
                                    <el-input-number :disabled="formData.serviceFeeType == 0" style="width:100%" v-model="formData.serviceFee" controls-position="right" :min="formData.serviceFeeType == 1 ? 0.01 : 0.00" :max="formData.serviceFeeType == 1 ? 99999999.99 : 100.00" :precision="2"></el-input-number>
                                </el-col>
                                <el-col :span="2">
                                    {{formData.serviceFeeType == 1 ? '元' : '%'}}
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>						
                </el-row>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>收款信息</span></div>
                <ReceiptInfo :formData.sync="formData"></ReceiptInfo>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>证件信息</span></div>
                <AccountInfo :formData.sync="formData" :type="1"></AccountInfo>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>状态信息</span></div>
                <StatusInfo :formData.sync="formData"></StatusInfo>
            </div>
            <div v-if="contractSn" class="group MT20">
                <ContractInfo :contractSn="contractSn" :userId="formData.userId"></ContractInfo>
            </div>
            <div class="group MT20">
                <el-button @click="goBack">返回</el-button>
                <el-button
                    v-if="$utils.have('/activity/receivables/updateInfo')"
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >提交</el-button
                >
            </div>
        </el-form>
    </div>
</template>

<script>

import UserInfo from './components/userInfo';
import ReceiptInfo from '@/views/finance/components/receiptInfo';
import AccountInfo from '@/views/finance/components/accountInfo';
import StatusInfo from './components/statusInfo';
import ContractInfo from './components/contractInfo';
export default {
    props:{
        id: {
            type: [Number, String],
            default: () => null
        }
    },
    components:{UserInfo,ReceiptInfo,AccountInfo,StatusInfo,ContractInfo},
    data(){
        return{
            formData:{
                bankCityCode: '',
                bankProvinceCode: '',
                accountIdName: "",
                accountPic: "",
                accountType: 1,//帐号类型：1：企业，2：个人或者其他
                address: "",
                bankAccount: "",
                bankAddress: "",
                bankCardId: "",
                bankId: 1,
                contractExpireTime: "",
                contractSn: "",
                id: 0,
                otherPic: "",
                userEmail: "",
                userId: "",
                userName: "",
                userTelephone: "",
                pic1:'',
                pic2:'',
                licenseNumber:'',
                serviceFee: "",
		        serviceFeeType: 0,
				//registeredAddress:'',
				//registeredCapitalStr:'',
				//businessType:'',
				corporationName:'',
				bankType:0,
				isExclusive:0,
				signTime:''
				
				
            },
            rules:{},
            dataLoading: false,
            btnLoading:false,
            redirect: this.$route.query.redirect || '/finance/activity/receivables/manage/list',
            contractSn:'',
        }
    },
    mounted(){
        if (this.id) {
            this.formData.id = this.id;
            this.getDataDetail();
        }
    },
    methods:{
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/activity/receivables/getInfoDetail",
                params: { id: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        const _accountPic = result.accountPic ? result.accountPic.split(',') : [];
                        this.formData = {
                            ...this.formData,
                            ...result,
                            pic1: _accountPic[0] || '',
                            pic2: _accountPic[1] || '', 
                        }
                        this.contractSn = this.formData.contractSn;
                    } else {
                        this.$message.error(msg || "获取信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        }, 
        
        //设置图片
        setAccountPic(){
            const _pic = [];
            if(this.formData.pic1) _pic.push(this.formData.pic1);
            if(this.formData.pic2) _pic.push(this.formData.pic2);

            this.formData.accountPic = _pic.toString(); 
        },
        //范围切换
        scopeChange(e) {
            if (e == 1) {
                this.formData.serviceFee = 10.00;
            }else{
                this.formData.serviceFee = 0.00;
            }
            this.$refs["formData"].clearValidate('serviceFee');
        },
        //表单提交
        onSubmit(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.setAccountPic();
                    this.$request({
                        url: "/activity/receivables/updateInfo",
                        method: "POST",
                        data: this.formData,
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.goBack();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-card{
    .el-col{
        line-height: 28px;
    }
}
</style>